import { OcpsPolicy } from './OcpsPolicy';
import { getOcpsPolicyName } from './getOcpsPolicyName';
import { getItem, itemExists, localStorageExists } from 'owa-local-storage';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function isOcpsPolicyEnabled(policy: OcpsPolicy): boolean {
    if (isConsumer() || !isFeatureEnabled('ocps-policy-check')) {
        return true;
    }

    let policyName = getOcpsPolicyName(policy);
    if (localStorageExists(window)) {
        if (itemExists(window, policyName)) {
            return getItem(window, policyName) == '1';
        }
    }

    return false;
}
